import styles from './notify-add.module.scss';
function NotifyAdd(props) {
  const { getLangMsg, getBtn, onCancel } = props;
  return (
    <div className={styles.notify}>
      <div className={styles.notify_msg}>{getLangMsg()}</div>
      <div className={styles.notify_cancelBtn} onClick={onCancel}>
        {getBtn()}
      </div>
    </div>
  );
}

export default NotifyAdd;
